let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1ONJO")).then(() => parcelRequire('2ayfU'));